
const TOKEN_SYMBOL_TO_ADDRESS = {
  SUSHI: "0x2c78f1b70ccf63cdee49f9233e9faa99d43aa07e",
};

const TOKEN_ADDRESS_TO_SYMBOL = Object.entries(TOKEN_SYMBOL_TO_ADDRESS).reduce((prev, curr) => ({
  ...prev,
  [curr[1]]: curr[0]
}), {});

const TOKEN_ADDRESS_TO_DECIMALS = {
  [TOKEN_SYMBOL_TO_ADDRESS.SUSHI]: 18,
};

const PREFERRED_SWAP_PATH_TOKEN_ADDRESS = TOKEN_SYMBOL_TO_ADDRESS.WMATIC;
const NATIVE_TOKEN = TOKEN_SYMBOL_TO_ADDRESS.WMATIC;

module.exports = {
  TOKEN_ADDRESS_TO_DECIMALS,
  TOKEN_SYMBOL_TO_ADDRESS,
  TOKEN_ADDRESS_TO_SYMBOL,
  PREFERRED_SWAP_PATH_TOKEN_ADDRESS,
  PROTOCOLS: {
  },
  NATIVE_TOKEN,
};
